var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArkhLetterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 42,
    viewBox: "0 0 287 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1512 0.598043L35.7032 41.1772H29.1684L18.1512 16.6495L7.13784 41.1767H0.609375L18.1487 0.597534L18.1512 0.598043ZM161.742 0.622476H168.04V41.1472H161.742V0.622476ZM196.198 0.735988L180.699 20.2926L200.639 41.1497H192.175L172.887 20.9416L189.017 0.736497L196.198 0.733443V0.735988ZM275.233 24.1245H257.736V41.1497H251.438V0.625021H257.736V18.4459H275.233V24.1245ZM280.657 0.625021H286.956V41.1497H280.657V0.625021ZM72.897 6.30315V0.624512L90.2292 0.619931C99.7797 0.581754 106.332 7.00204 106.332 14.8919C106.332 21.9825 101.069 28.0791 92.9011 29.0035H92.8908L104.957 41.1497H97.5236L80.3834 24.0028H81.8036L91.0054 23.9326C96.1475 23.9326 100.477 19.9424 100.477 15.0756C100.477 10.2089 96.1475 6.30824 91.0054 6.30824L73.2555 6.30315H72.897Z",
    fill: "#FFFBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkhLetterLogo);
export default __webpack_public_path__ + "static/media/ARKH-letter-logo.24a28c94aa71fa1371e6299e64e88a41.svg";
export { ForwardRef as ReactComponent };